export const extraSmall = 'screen and (max-width: 350px)'
export const tablet = 'screen and (min-width: 1104px)'
export const mobileDiscount =
  'screen and (min-width: 350px) and (min-height: 500px)'
export const mobile = 'screen and (min-width: 350px) and (min-height:575px)'
